/**
* @file Header
* @author Ice(chenzhouji@baidu.com)
*/
import React, {FunctionComponent, useEffect, useState} from 'react';

// 1、由于是server-side-render，无法获取到当前是沙盒还是线上环境，只能动态加载资源
// 2、动态加载的js不会阻塞后续代码执行，因此在加载完成后依然无法获取portalCommon，设置定时器获取
// 3、portal-common支持require的形式，如果esl.js先于portal-common加载，会执行define('portalCommon', ...)
//   不会把portalCommon挂载在window上，因此需要使用require形式。
const headerSetup = () => {
    const timer = setInterval(() => {
        if (window.portalCommon) {
            window.portalCommon.setup();
            clearInterval(timer);
            return;
        }

        if (window.require) {
            try {
                window.require(['portalCommon'], function(portalCommon:any) {
                    if (portalCommon) {
                        portalCommon.setup();
                        clearInterval(timer);
                    }
                });
            }
            catch {};
        }
    }, 50)
}

const PortalHeader: FunctionComponent = () => {
    const injectTJ = () => {
        var _hmt: any = _hmt || [];
        window._hmt = _hmt;
        var _bdhmProtocol = (('https:' == document.location.protocol) ? ' https://' : ' http://');
        var hm = document.createElement("script");
        hm.src = _bdhmProtocol + 'hm.baidu.com/hm.js?28a17f66627d87f1d046eae152a1c93d';
        var s = document.getElementsByTagName("script")[0];
        s.parentNode && s.parentNode.insertBefore(hm, s);
    };

    const loadPortalCommon = (env:string) => {
        var commonScript = document.createElement("script");
        commonScript.src = `https://bce.bdstatic.com/fe-static/baidu/bce-portal/portal-common-intl/load.${env}.js`;

        var s = document.getElementsByTagName("script")[0];
        s.parentNode?.insertBefore(commonScript, s);

        s.onload = headerSetup;
    }

    useEffect(() => {
        injectTJ();
    }, []);

    useEffect(() => {
        // 默认加载线上header
        window?.portalCommon?.setup();

        // 如果环境是沙盒，则替换为沙盒header
        const w: any = window;
        const env = /(cloudtest\.(baidu|baidu-int)\.com)|(\:8289$)|localhost/.test(w.location.host) ? 'sandbox' : 'online';

        if (env === 'sandbox') {
            window.portalCommon = undefined;
            loadPortalCommon('sandbox');
        }

    }, []);

    return <script src="https://bce.bdstatic.com/fe-static/baidu/bce-portal/portal-common-intl/load.online.js" />;
};

export default PortalHeader;
